import { render } from "./termsAndConditions.vue?vue&type=template&id=245bf7ae"
import script from "./termsAndConditions.vue?vue&type=script&lang=js"
export * from "./termsAndConditions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__